/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./star-button.vue?vue&type=template&id=7dbd68fa&scoped=true&"
import script from "./star-button.vue?vue&type=script&lang=js&"
export * from "./star-button.vue?vue&type=script&lang=js&"
import style0 from "./star-button.vue?vue&type=style&index=0&id=7dbd68fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd68fa",
  null
  
)

export default component.exports